<div class="container">
  <div class="header">
    <h1>{{ 'user.personal_data' | translate }}</h1>
    <button im-button class="mobile-button inverted btn-sm" (click)="editProfile()">
      {{ 'account.edit_data_a' | translate }}
    </button>

    @if (showProfileButton$ | async) {
      <button im-button class="inverted" (click)="editProfile()">
        {{ 'account.edit_data_a' | translate }}
      </button>
    }
  </div>

  <hr />

  <div class="profile-container rounded">
    <div class="tab rounded profile-details">
      <rs-web-profile-details [userData]="userData" [noData]="noData"></rs-web-profile-details>
    </div>
    <div class="d-flex flex-column contact-payment-details">
      <div class="tab rounded">
        <rs-web-user-contact-details
          [userData]="userData"
          [noData]="noData"
        ></rs-web-user-contact-details>
      </div>
    </div>
  </div>
</div>

<ng-template #noData><span>---</span></ng-template>
